<div *ngIf="flightTrackerText$ | async as flightTrackerText">
  <div class="fl w-30 b dn-ns">
    <span class="clip"
      >{{ flightTrackerText?.tabletStickyScheduledArrival }}:&nbsp;</span
    >
    {{ convertTime(leg?.scheduledArrival) | date: 'shortTime' }}
  </div>

  <div class="fl arrival-column pv1 dn db-ns">
    <div class="flex flex-column">
      <span class="clip">{{
        flightTrackerText?.tabletStickyScheduledArrival
      }}</span>
      <div class="f4 b">
        {{ convertTime(leg?.scheduledArrival) | date: 'shortTime' }}
      </div>
      <div
        *ngIf="
          leg?.actualArrival !== null &&
          leg?.actualArrival !== leg?.scheduledArrival
        "
        class="pt1"
      >
        <span
          *ngIf="leg?.flightStatus | jbIncludesSubstring: 'DELAY'"
          class="orange"
          >&#9679;</span
        >
        {{ flightTrackerText?.now }}
        {{ convertTime(leg?.actualArrival) | date: 'shortTime' }}
      </div>
    </div>
  </div>
</div>
